import React from "react";
import { Tooltip } from "@mui/material";
import VendorResponseMetrics from "./VendorResponseMetrics";

export default function MarketplaceRecommendationCells({ vendor, insight, status, verified }) {
  const loading = status === "loading" || status === "idle";
  const references = verified
    ? (insight?.verifiedClients || []).map((client) => client.entityName)
    : vendor.clientNames || [];
  const names = [...new Map(references.filter((name) => typeof name === "string" && name.trim())
    .map((name) => [name.trim().toLowerCase(), name.trim()])).values()];

  return <>
    <td className="min-w-[165px] px-3 py-3 align-middle text-xs text-gray-700">
      {verified && loading ? <span role="status" className="text-gray-400">Loading...</span>
        : verified && status === "error" ? <span title="Verified company references are temporarily unavailable.">Unavailable</span>
          : names.length ? <div className="flex flex-wrap items-center gap-x-1.5 gap-y-1">
            {names.slice(0, 2).map((name, index) => <Tooltip key={name} title={verified ? "Company verified from completed RFQ awards on Neevay." : "Client reference provided by the supplier; not verified."}>
              <span className="inline-flex items-center gap-1">
                {name}{index < Math.min(names.length, 2) - 1 ? "," : ""}
                {verified && <svg aria-label="Verified company" role="img" viewBox="0 0 20 20" className="h-3.5 w-3.5 shrink-0 text-emerald-600" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>}
              </span>
            </Tooltip>)}
            {names.length > 2 && <Tooltip title={names.slice(2).join(", ")}><span tabIndex={0} className="rounded-full bg-blue-50 px-1.5 py-0.5 text-[10px] font-semibold text-blue-700">+{names.length - 2} more</span></Tooltip>}
          </div> : <span title={verified ? "No completed RFQ award references recorded." : "No client references added."}>-</span>}
    </td>
    <VendorResponseMetrics insight={insight} status={status} />
  </>;
}
